import React, {Component} from 'react';
import { Modal, Icon } from 'antd';
import ReactGA from 'react-ga';

import logo from '../../img/logo.png'

import './styles.css';

class Header extends Component {

  info =()=> {
    ReactGA.event({
      category: 'Events',
      action: 'Viewed "What is this?"'
    })

    Modal.info({
      title: 'What is Merch Resize?',
      content: (
        <div>
        <p>Merch Resize is a simple online tool to resize your artwork for the various Merch by Amazon products.</p>
        <p>None of your designs  are uploaded to a server as we process everything in your browser.</p>
        <p>We only use 1 cookie for Google Analytics.</p>
        <p>If you find a bug or need to report a problem, please tag me in one of the Merch by Amazon Facebook Groups and we will take a look.</p>
        <p>Copyright 2020 &copy;	Merch Resize</p>
        </div>
      ),
      onOk() {},
    });
  }

  whatsnew =()=> {
    ReactGA.event({
      category: 'Events',
      action: 'Viewed "Whats New?"'
    })

    Modal.info({
      title: 'Whats New?',
      content: (
        <div>
          <dl>
            <dt>11th January '21</dt>
            <dd>- Added support T-Shirts (Note: File sizes might be a lot bigger than expected)</dd>
          </dl>
          <dl>
            <dt>17th November</dt>
            <dd>- Added support for Tote Bag & Pillow resizing</dd>
          </dl>
          <dl>
            <dt>9th July 2020</dt>
            <dd>- Added support for iPhone and Samsung Cases</dd>
            <dd>- Note: These products may take longer to process due to the increases dimensions</dd>
          </dl>
        <dl>
          <dt>15th November</dt>
          <dd>- Added support for Hoodie resizing</dd>
          <dd>- Note: Hoodie file sizes may be larger due to how the browser processes images</dd>
        </dl>
        <dl>
          <dt>20th June</dt>
          <dd>- Huge improvements to efficiency. Merch Resize should now be at least 10x faster</dd>
          <dd>- Image duplication means you can duplicate your images so you can have multiple background colors</dd>
          <dd>- File renaming has been added</dd>
        </dl>
        <dl>
          <dt>18th June</dt>
          <dd>- Initial Launch of Merch Resize</dd>
        </dl>
        </div>
      ),
      onOk() {},
    });
  }

  render() {
    return (
      <div className="head-header">
        <div className="head-logo">
          <img src={logo} alt="Merch Resize" />
        </div>
        <div className="head-menu">
          <div><a href="https://www.facebook.com/groups/269197683638891" target="_blank" rel="noopener noreferrer"><Icon type="facebook" style={{ color: '#fff' }} /></a></div>
          <div onClick={this.info}>What is this?</div>
          <div onClick={this.whatsnew}>Whats new?</div>
        </div>
      </div>
    );
  }

}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js